import { DOWNLOAD_FILES_QUERY } from './download-files.query';
import { graphql } from '../gql';
import { useMutation } from '@apollo/client';

const UNDERWRITING_EVALUATION_MUTATION = graphql(`
  mutation createUnderwritingEvaluation($submissionUuid: String!) {
    createUnderwritingEvaluation(submissionUuid: $submissionUuid) {
      result
      savedDocuments
      folder
    }
  }
`);

export function useUnderwritingEvaluationMutation() {
  const [createUnderwritingEvaluation, { data, loading, error, reset }] =
    useMutation(UNDERWRITING_EVALUATION_MUTATION, {
      refetchQueries: [DOWNLOAD_FILES_QUERY],
      awaitRefetchQueries: true,
    });
  return {
    data,
    createUnderwritingEvaluation,
    loading,
    error,
    reset,
  };
}
